const isProd = import.meta.env.VITE_APP_NODE_ENV === 'production';

export const msalConfig = {
    auth: {
        clientId: isProd
            ? '2f98a6c0-908a-43b6-b140-a98381e64e58'
            : 'e4fe35b1-3437-457b-b70c-3afd1e41e758',
        authority: isProd
            ? 'https://login.microsoftonline.com/68283f3b-8487-4c86-adb3-a5228f18b893'
            : 'https://login.microsoftonline.com/600fc84d-b45f-4cc5-8ea4-63619872e13f',
        redirectUri: '/login',
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const msGraphScopes = {
    scopes: ['openid', 'profile', 'email', 'User.Read']
};

export const apiScopes = {
    scopes: isProd
        ? ['api://36bfe50e-97d3-4d48-bb17-afedbd268682/api.access']
        : ['api://ac609d96-9db2-4b4c-a616-8d43546835d0/api.access']
};